<div class="container h-100 d-flex align-items-center justify-content-center">
    <div class="row">
        <div class="col-12">
            <div class="border shadow-lg p-5 bg-white rounded">
                  <img class="mb-4" src="./assets/images/logo_Luiss.png" height="40">
                  Non sei autorizzato ad accedere a questa pagina!
                  <button class="btn btn-primary w-100 mt-2" (click)="hS.routeInit()">
                      <span>Home</span>
                  </button>
            </div>
        </div>
    </div>
</div>